export const isDateString = (inputString: string): boolean => {
  return Boolean(inputString && !isNaN(Date.parse(inputString)));
};
